import React from 'react';
import './index.css';

export default function NavBar() {
  return (
    <div className="sectionComponent">
      <div id="divTwo">
        <div id="nav">
          <ul>
            <li>
              <a href="#home">Home</a>
            </li>

            <li>
              <a href="#about">About Me</a>
            </li>

            <li>
              <a href="#edu">Experience</a>
            </li>

            <li>
              <a href="#projects">Projects</a>
            </li>

            <li>
              <a href="#contact">Contact</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
